export const generate = o => {
    return { ...o, id: Date.now() };
}
